import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useDailyBrief } from '../../hooks/useDailyBrief';
import { stripMarkdown } from '../common/RichText';
import styles from './HomeBriefSnippet.module.css';

const MAX = 360;

function truncate(s: string): string {
  if (s.length <= MAX) return s;
  return s.slice(0, MAX).replace(/\s+\S*$/, '') + '…';
}

export function HomeBriefSnippet(): JSX.Element | null {
  const navigate = useNavigate();
  const { t } = useTranslation(['home', 'common']);
  const { data, isLoading } = useDailyBrief();

  if (isLoading) {
    return <div className={styles.skeleton} data-testid="home-brief-skeleton" aria-hidden="true" />;
  }
  if (!data || data.text == null) {
    return <p className={styles.empty} data-testid="home-brief-empty">{t('brief.empty')}</p>;
  }

  return (
    <div className={styles.snippet} data-testid="home-brief-snippet">
      <p className={styles.text}>{truncate(stripMarkdown(data.text))}</p>
      <button
        type="button"
        className={styles.more}
        onClick={() => void navigate('/me/daily-brief')}
        data-testid="home-brief-more"
      >
        {t('brief.more')}
      </button>
    </div>
  );
}
